export default __webpack_public_path__ + "static/media/chat.5a84e5c4.svg";